module.exports = __webpack_public_path__ + "r-v3/img/trashcan.b60669fe.svg";